module.exports = __webpack_public_path__ + "img/2_90.2f04909d.png";